export class ServiceFee {
  public fee: number;

  constructor(fee) {
    this.fee = fee;
  }

  json() {
    return {
      fee: this.fee
    };
  }

  wrap(){
    return {
      ingredient_type: "ServiceFee",
      ingredient: this.json()
    };
  }
}
